<ng-container *ngIf="initialized">
    <mvs-widget *ngIf="coveragesWidget"
                [widgetData]="coveragesWidget">
    </mvs-widget>
</ng-container>
